// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-react {\n  position: relative;\n}\n.video-react .video-react-big-play-button {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  border-radius: 50%;\n  height: 60px;\n  width: 60px;\n}\n.video-react .video-react-big-play-button:before {\n  top: 10%;\n}\n.video-react-playing .video-react-big-play-button {\n  display: none !important;\n}", ""]);
// Exports
module.exports = exports;
